<template>
  <div class="card card-secondary card-outline mb-4 mt-4">
    <!--begin::Header-->
    <div class="card-header"><div class="card-title">{{ cardTitle }}</div></div>
    <!--end::Header-->
    <!--begin::Form-->
    <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
    <successAlert v-if="hasSucess" :message="message" />
    <!--begin::Body-->
    <div class="card-body">
      <div class="row">
        <div class="col-12 col-sm-6 mb-3">
          <label for="" class="form-label">مقدم الطلب:</label>
          <div>{{ (dataRow.User)? dataRow.User.name : 'غير معروف' }}</div>
        </div>
        <div class="col-12 col-sm-6 mb-3">
          <label for="" class="form-label">تاريخ الطلب:</label>
          <div class="date-format">{{ formatDate(dataRow.createdAt) }}</div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-sm-6 mb-3">
          <label for="" class="form-label">باسم:</label>
          <div>{{ dataRow.name }}</div>
        </div>
        <div class="col-12 col-sm-6 mb-3">
          <label for="" class="form-label">رقم الجوال:</label>
          <div>{{ dataRow.mobile }}</div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 mb-3">
          <label for="" class="form-label">الموضوع:</label>
          <div><pre>{{ dataRow.subject }}</pre></div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-sm-6 mb-3">
          <label for="" class="form-label">حالة الطلب:</label>
          <div>{{ statusChoices[status] }}</div>
        </div>
      </div>

      <div v-if="dataRow.attachments && dataRow.attachments.length" class="row">
        <div class="col-12 mb-3">
          <label for="" class="form-label">المرفقات:</label>
          <div v-for="(f, indx) in dataRow.attachments" :key="indx">
            <a :href="`${BASE_URL}uploads/${f}`" target="_blank">{{ f }}</a>
          </div>
        </div>
      </div>
    </div>
    <!--end::Body-->
  </div>
</template>

<script>
import { formatDate } from '@/helpers/tools';
import { mapGetters } from 'vuex';

export default {
  name: 'ContactUsView',
  props: {
    cardTitle: {
      type: String,
      default: 'إضافة'
    },
    dataRow: {
      type: Object,
      default: null,
    },
    statusObject: {
      type: Object,
      default: null,
    },
  },
  data(){
    return {
      formLoader: false,
      hasError: false,
      hasSucess: false,
      message: '',
      errorNumber: 0,
      statusChoices: {},
      status: 'new',
    }
  },
  computed:{
    ...mapGetters(['BASE_URL'])
  },
  methods: {
    formatDate,
  },
  created(){
    if(this.dataRow){
      this.status = this.dataRow.status;
    }
    this.statusChoices = this.statusObject;
  }
}
</script>
